import { isBaseUrlProd } from '@shared';
import { STRIPE_PUBLISHABLE_KEY, DEV_STRIPE_PUBLISHABLE_KEY } from './constants';

export const getStripePublishableKey = () => {
  const isProd = isBaseUrlProd();
  return isProd ? STRIPE_PUBLISHABLE_KEY : DEV_STRIPE_PUBLISHABLE_KEY;
};
